import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { useLocation, useNavigate } from 'react-router-dom';
import { TWO_FACTOR_SCHEMA } from '../../utils/twoFactor.js';
import { useResendTwoFactorMutation, useTwoFactorMutation } from '../../api/auth.js';
import { useErrors } from '../../hooks/useErrors.js';
import GuestLayout from '../../components/layout/GuestLayout.jsx';
import BaseInput from '../../components/form/BaseInput.jsx';
import BaseButton from '../../components/form/BaseButton.jsx';
import BaseCheckbox from '../../components/form/BaseCheckbox.jsx';
import BaseLink from '../../components/misc/BaseLink.jsx';

const TwoFactor = () => {
    const mfaIdentifier = sessionStorage.getItem('mfaIdentifier') || '';
    const navigate = useNavigate();
    const location = useLocation();

    const [twoFactor, { isLoading, error }] = useTwoFactorMutation();
    const [resendTwoFactor, { isLoading: isLoadingResend }] = useResendTwoFactorMutation();

    const { handleSubmit, getValues, formState, control, clearErrors } = useForm({
        resolver: yupResolver(TWO_FACTOR_SCHEMA),
        defaultValues: {
            identifier: mfaIdentifier,
            token: '',
            remember: false
        },
        reValidateMode: 'onSubmit'
    });

    const { errors } = useErrors(error?.message, formState);

    const validateTwoFactor = async (data) => {
        await twoFactor({
            identifier: data.identifier,
            token: data.token,
            remember: data.remember
        }).then((apiResponse) => {
            if (apiResponse.data?.success) {
                sessionStorage.removeItem('mfaIdentifier');
                localStorage.setItem('mfaIdentifier', mfaIdentifier);
                const redirectTo = location.state?.from?.pathname || '/dashboard';
                navigate(redirectTo, { replace: true });
            }
        });
    };

    const resendTwoFactorEmail = async () => {
        await resendTwoFactor({
            identifier: mfaIdentifier
        });
    };

    const formValues = getValues();

    return (
        <GuestLayout title='Two Factor Authentication'>
            <div className='mb-10'>
                <BaseInput
                    type='text'
                    control={control}
                    placeholder='Token'
                    name='token'
                    clearErrors={clearErrors}
                    errors={[...(errors?.token ? errors.token : [])]}
                />

                <BaseCheckbox
                    className='mt-4'
                    control={control}
                    label='Remember this device'
                    name='remember'
                    labelClassName='text-theme1-white cursor-pointer'
                />

                <BaseButton
                    id='btn-submit'
                    className='mt-10 btn-primary-white'
                    onClick={handleSubmit(validateTwoFactor)}
                    isLoading={isLoading}
                    textValue='Authorize'
                    disabled={!formValues.token}
                />
            </div>

            <div className='mb-4 flex justify-center'>
                <BaseButton
                    id='btn-resend'
                    className='btn-primary-white'
                    onClick={resendTwoFactorEmail}
                    isLoading={isLoadingResend}
                    textValue='Send new token'
                />
            </div>

            <div className='flex justify-center'>
                <BaseLink className='btn-link-guest-white' to='/logout'>
                    Logout
                </BaseLink>
            </div>
        </GuestLayout>
    );
};
export default TwoFactor;
